import { AccountClient } from '@frontend/account/api';
import { Account, AccountQueryParams } from '@frontend/account/types';
import { ObjectSelectInputV2, ObjectSelectV2Props } from '@frontend/form';
import React, { useState } from 'react';

const ID = 'account-select';
export interface AccountSelectProps extends ObjectSelectV2Props<Account, AccountQueryParams> {}
/**
* @deprecated
*/
export const AccountSelect = (props: AccountSelectProps) => {
    const [v, cV] = useState<Account | null>(null);
    return (
        <ObjectSelectInputV2<Account, AccountQueryParams>
            {...props}
            id={`${ID}${props.id && '-' + props.id}`}
            label={props.label || 'Account'}
            className={props.className}
            onChange={(v) => {
                props.onChange && props.onChange(v?.id || null);
                props.onChangeObject && props.onChangeObject(v);
                cV(v);
            }}
            required={props.required}
            queryParams={props.queryParams}
            value={v}
            idValue={props.value || v?.id}
            fetch={(arg) => AccountClient.fetchAccounts({ ...arg, sort_field: 'name', sort_direction: 'asc' })}
            itemLabel={(account) => account.name}
            useQueryParam={
                props.allowURLChange
                    ? {
                          param: 'account',
                          fetch: (pathParam) => AccountClient.fetchAccount(pathParam)
                      }
                    : undefined
            }
            disabled={props.disabled}
            isClearable={props.isClearable}
        />
    );
};
